import { CircleInfoIcon } from "@xola/icons";
import { Alert, formatDate, Switch, Tooltip } from "@xola/ui-kit";
import { DateFormat, FormField, InputField } from "common";
import React from "react";
import { Experience, Timeslot } from "types";
import { useResource } from "../../../hooks/useResource";
import { CancelBookingsFormValues } from "./EventBookingsTable";

interface CancelOptionsProps {
    bookingsCount: number;
    selectedCount: number;
    timeslot: Timeslot;
    values: CancelBookingsFormValues;
    onChange: (field: string, value: string | boolean) => void;
}

export const CancelOptions = ({ selectedCount, bookingsCount, timeslot, values, onChange }: CancelOptionsProps) => {
    const { data: experience } = useResource<Experience>(["products", timeslot.product]);
    return (
        <div className="space-y-4 text-gray-darker">
            <FormField name="reason" label="Reason">
                <InputField isRequired placeholder="Reason" />
            </FormField>
            <div className="space-y-4.5">
                <div className="block">
                    <Switch.Group>
                        <Switch
                            size="medium"
                            isChecked={values.blackoutEvent}
                            data-testid="cancel-options-blackout-this-event-checkbox"
                            onChange={(value: boolean) => {
                                onChange("blackoutEvent", value);
                            }}
                        />
                        <Switch.Label direction="right">Blackout this event to prevent future reservation</Switch.Label>
                    </Switch.Group>
                </div>
                {values.blackoutEvent ? (
                    <Alert color="warning">
                        <p>
                            A blackout schedule will be created for{" "}
                            <var data-var="arrtivalDateTime">
                                {formatDate(timeslot.arrivalDatetime, DateFormat.DATE_TIME)}
                            </var>{" "}
                            This event will no longer accept bookings however existing reservations will be retained.
                        </p>
                        <br />
                        <p>
                            To get this capacity back, you may delete the blackout schedule from
                            <var data-var="experienceName"> {experience?.name}</var> settings
                        </p>
                    </Alert>
                ) : null}
                <div className="block">
                    <Switch.Group>
                        <Switch
                            disabled={selectedCount !== bookingsCount}
                            isChecked={values.removeGuides}
                            size="medium"
                            data-testid="cancel-options-remove-assigned-guide-from-this-event-checkbox"
                            onChange={(value: boolean) => onChange("removeGuides", value)}
                        />
                        <Switch.Label direction="right">Remove assigned guide(s) from this event</Switch.Label>
                    </Switch.Group>
                </div>
                <div className="block">
                    <Switch.Group>
                        <Switch
                            isChecked={values.removeAffiliates}
                            size="medium"
                            data-testid="cancel-options-remove-affiliate-discount-deposit-and-commision-checkbox"
                            onChange={(value: boolean) => {
                                onChange("removeAffiliates", value);
                            }}
                        />
                        <Switch.Label direction="right">
                            Remove Partner discount, deposit and commission{" "}
                            <Tooltip
                                content="Agent discount, deposit and commission will not be removed for any booking created by a agent"
                                className="ml-2"
                            >
                                <CircleInfoIcon />
                            </Tooltip>
                        </Switch.Label>
                    </Switch.Group>
                </div>
            </div>
        </div>
    );
};
